export default IconBrandParsinta => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-parsinta" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 3a9 9 0 1 0 9 9" />
  <path d="M21 12a9 9 0 0 0 -9 -9" opacity=".5" />
  <path d="M10 9v6l5 -3z" />
</svg>`;